import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import { mockBlogPosts } from '../data/mockData';

export default function Blog() {
  return (
    <section id="blog" className="py-20 px-6 lg:px-[7.69%] bg-bg-panel">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex justify-between items-end mb-10 border-b border-border-medium pb-6">
          <div>
            <span className="section-tag">/Insights</span>
            <h2 className="display-medium">Latest Insights</h2>
          </div>
          <a href="#" className="hidden md:flex items-center gap-2 text-brand-primary hover:text-text-primary transition-colors uppercase" style={{ fontSize: '10px', fontWeight: 700, letterSpacing: '0.8px' }}>
            Read The Journal <ArrowUpRight className="w-3.5 h-3.5" />
          </a>
        </div>

        <div className="flex flex-col gap-8">
          {mockBlogPosts.map((post) => (
            <div key={post.id} className="group flex flex-col md:flex-row gap-4 md:gap-10 md:items-center py-6 border-b border-border-subtle hover:border-brand-primary/40 transition-colors cursor-pointer">
              <div className="md:w-1/4 uppercase" style={{ fontSize: '10px', letterSpacing: '0.8px' }}>
                <span className="text-brand-primary font-bold">{post.date}</span>
                <span className="mx-2 text-text-muted">|</span>
                <span className="text-text-muted">{post.readTime}</span>
              </div>

              <div className="md:w-1/2">
                <h3 className="heading-2 mb-2 group-hover:text-brand-primary transition-colors">{post.title}</h3>
                <p className="body-medium line-clamp-2">{post.excerpt}</p>
              </div>

              <div className="md:w-1/4 flex justify-end opacity-0 group-hover:opacity-100 transition-opacity transform translate-x-[-10px] group-hover:translate-x-0">
                <div className="w-9 h-9 border border-brand-primary flex items-center justify-center">
                  <ArrowUpRight className="w-4 h-4 text-brand-primary" />
                </div>
              </div>
            </div>
          ))}
        </div>
        
        <div className="mt-10 md:hidden">
           <a href="#" className="flex items-center gap-2 text-brand-primary uppercase" style={{ fontSize: '10px', fontWeight: 700, letterSpacing: '0.8px' }}>
            Read The Journal <ArrowUpRight className="w-3.5 h-3.5" />
          </a>
        </div>
      </div>
    </section>
  );
}
